import { Component, OnInit } from '@angular/core';
import { ActuatorService } from '../../../services/actuator/actuator.service';

@Component({
    selector: 'lib-order-context',
    templateUrl: './order-context.component.html',
    styleUrls: ['./order-context.component.css'],
    standalone: false
})
export class OrderContextComponent implements OnInit {
  error;
  context = '';
  contextId: string;
  data;
  loading = false;
  steps: any
  selectedStep: string;
  constructor(protected actuatorService: ActuatorService) {}

  ngOnInit(): void {}

  sendOrderContext() {
    this.error = null;
    this.loading = true;
    if (this.context) {
      this.actuatorService.sendOrderContext(this.context).subscribe(
        data => {
          this.loading = false;
          this.data = data;
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  }

}
